import React, { useCallback, useEffect, useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";

//apollo

import InvoiceTab from "./components/InvoiceTab";
import HeaderTitle from "./components/HeaderTitle";

import {
  Table,
  Button,
  Modal,
  Spinner,
  InputGroup,
  Form,
} from "react-bootstrap";
import { GET_INVOICES } from "../../graphql/invoice/query";
import * as _ from "lodash";
import moment from "moment";
import InvoiceDetail from "./components/InvoiceDetail";
import { GET_BANKS } from "../../graphql/bank/query";
import PaginationsV1 from "../../components/PaginationV1";
import { UPDATE_INVOICE_TO_REJECT } from "../../graphql/invoice/mutation";
import { successSwal } from "../../helpers/sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel } from "@fortawesome/free-solid-svg-icons";
import ModalConfirmComponent from "../../components/ModalConfirmComponent";
import LoadingSpinner from "../../components/LoadingSpinner";

function InvoiceRequesting() {
  let shopId = localStorage.getItem("SHOP");

  const [invoiceLists, setInvoicesLists] = useState([]);
  const [invoiceListsTotal, setInvoicesTotal] = useState(0);

  //detail invoice
  const [invoiceDetail, setInvoiceDetail] = useState({
    show: false,
    data: null,
  });

  const [showConfirmReject, setShowConfirmRemove] = React.useState(false);
  const [getInvoiceId, setGetInvoiceID] = React.useState("");

  const handleCloseConfirmReject = () => setShowConfirmRemove(false);
  const handleRejectStatus = (id) => {
    setShowConfirmRemove(true);
    setGetInvoiceID(id);
  };
  const rowsPerPage = 30;
  const [page, setPage] = useState(0);
  const pageAll =
    invoiceListsTotal > 0 ? Math.ceil(invoiceListsTotal / rowsPerPage) : 1;
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const [getInvoiceData, { data: invoiceData, loading: invoiceLoading }] =
    useLazyQuery(GET_INVOICES, {
      fetchPolicy: "network-only",
      variables: {
        where: {
          shop: shopId,
          invoiceType: "SP_INVOICE"

        },
        limit: rowsPerPage,
        skip: page * rowsPerPage,
      },
    });

  const [getBank, { data: bankData, loading: loadingBanks }] = useLazyQuery(
    GET_BANKS,
    {
      fetchPolicy: "cache-and-network",
    }
  );

  const [updateRejectInvoice, { loading: loadingReject }] = useMutation(
    UPDATE_INVOICE_TO_REJECT
  );

  //useEffect for fetch data

  const [filter, setFilter] = useState({});

  useEffect(() => {
    filterInvoiceDatas();
  }, [
    shopId,
    filter?.searchText,
    filter?.currentStartDate,
    filter?.currentEndDate,
  ]);

  const filterInvoiceDatas = () => {
    let _where = {
      shop: shopId,
      // status: "REQUEST",
      invoiceType: "SP_INVOICE"
    };

    if (!_.isEmpty(filter?.searchText)) {
      _where = {
        ..._where,
        invoiceNubmer: filter?.searchText,
      };
    }

    if (!_.isEmpty(filter?.statusSelect)) {
      _where = {
        ..._where,
        status: filter?.statusSelect,
      };
    }

    if (
      !_.isEmpty(filter?.currentStartDate) &&
      !_.isEmpty(filter?.currentEndDate)
    ) {
      _where = {
        ..._where,
        createdAt_gte: new Date(
          moment(
            moment(filter?.currentStartDate).format("YYYY-MM-DD")
          ).toISOString()
        ),
        createdAt_lt: new Date(
          moment(moment(filter?.currentEndDate).add(1, "days")).format(
            "YYYY-MM-DD"
          )
        ).toISOString(),
      };
    }

    getInvoiceData({
      variables: {
        where: _where,
        limit: rowsPerPage,
        skip: page * rowsPerPage,
      },
    });
  };

  const handleUpdateRejectInvoice = async () => {
    try {
      if (loadingReject) return;

      const rejectInvoice = await updateRejectInvoice({
        variables: {
          where: {
            id: getInvoiceId,
          },
          data: {
            status: "REQUEST",
          },
        },
      });

      if (rejectInvoice) {
        getInvoiceData();
        successSwal("ຍົກເລິກແຈ້ງຖອນເງິນສຳເລັດແລ້ວ");
        setShowConfirmRemove(false);
        setInvoiceDetail(false);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getInvoiceData();
  }, []);

  // ເອົາຮູບ qrcode ຂອງຮ້ານມາສະແດງ
  useEffect(() => {
    // initSetting();
    _getBank(shopId);
  }, [shopId]);

  useEffect(() => {
    if (invoiceData?.invoices) {
      setInvoicesLists(invoiceData?.invoices?.data);
      setInvoicesTotal(invoiceData?.invoices?.total);
    }
  }, [invoiceData?.invoices]);

  // pagegination

  // console.log("invoiceLists==555===>", invoiceLists);

  const _getBank = async (shopId) => {
    try {
      // let SHOP_ID = await localStorage.getItem("SHOP");
      await getBank({
        variables: {
          where: {
            shop: shopId,
            isDeleted: false,
          },
          skip: 0,
          limit: 100,
          orderBy: "createdAt_DESC",
        },
      });

      return;
    } catch (err) {
      console.log(err);
    }
  };

  // console.log("invoiceData--->", invoiceData);

  return (
    <>
      <div>
        {/* header  */}
        <HeaderTitle />
        {/* header  */}
        <div style={{ padding: "0 9px" }}>
          {/* invoice */}
          <InvoiceTab />
          {/* invoice */}

          {/* show list invoice */}
          <ListOrder
            invoiceLists={invoiceLists}
            invoiceListsTotal={invoiceListsTotal}
            invoiceLoading={invoiceLoading}
            setInvoiceDetail={setInvoiceDetail}
            filter={filter}
            setFilter={setFilter}
            filterInvoiceDatas={filterInvoiceDatas}
            handleRejectStatus={handleRejectStatus}
            loadingReject={loadingReject}
            page={page}
            pageAll={pageAll}
            handleChangePage={handleChangePage}
            rowsPerPage={rowsPerPage}
          />
          {/* show list invoice */}

          {/* show detail invoice */}
          <InvoiceDetail
            invoiceDetail={invoiceDetail}
            handleRejectStatus={handleRejectStatus}
            bankData={bankData}
            handleClose={() => setInvoiceDetail({ show: false, data: null })}
          />

          {/* show detail invoice */}
        </div>
      </div>

      <ModalConfirmComponent
        showConfirmModal={showConfirmReject}
        handleCancel={handleCloseConfirmReject}
        loadingConfirm={loadingReject}
        handleConfirm={handleUpdateRejectInvoice}
        title="ແຈ້ງເຕືອນ"
        text="ຕ້ອງການຍົກເລິກການແຈ້ງຖອນເງິນແທ້ບໍ?"
      />
    </>
  );
}

export default InvoiceRequesting;

const ListOrder = ({
  invoiceLists,
  invoiceListsTotal,
  invoiceLoading,
  setInvoiceDetail,
  filter,
  setFilter,
  handleRejectStatus,
  rowsPerPage,
  page,
  pageAll,
  handleChangePage,
  loadingReject,
}) => {
  // if(invoiceLists?.length === 0) return <p>Empty page</p>

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
        }}>

        <div className="card-actions-table">
          <div className="box-filter">
            <label>ຄົ້ນຫາດ້ວຍເລກບິນ</label>
            <InputGroup className="mb-3">
              <Form.Control
                placeholder="ປ້ອນເລກບິນ..."
                aria-describedby="basic-addon1"
                onChange={(e) => {
                  setFilter({ ...filter, searchText: e?.target?.value });
                }}
                value={filter?.searchText}
              />
            </InputGroup>
          </div>
          <div className="box-filter">
            <label>ຕັ້ງແຕ່ວັນທີ</label>
            <input
              type="date"
              className="form-control"
              value={filter?.currentStartDate}
              onChange={(e) =>
                setFilter({ ...filter, currentStartDate: e?.target?.value })
              }
            />
          </div>
          <div className="box-filter">
            <div className="w-100">
            <label>ຫາ ວັນທີ</label>
            <input
              type="date"
              className="form-control"
              value={filter?.currentEndDate}
              onChange={(e) =>
                setFilter({ ...filter, currentEndDate: e?.target?.value })
              }
            />
            </div>
          </div>
        </div>
      </div>

      <p style={{ fontWeight: 700, fontSize: 22 }}>
        ຈຳນວນສະແດງທັງໝົດ ({invoiceListsTotal})
      </p>

      {invoiceLoading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <LoadingSpinner />
        </div>
      ) : (
        <Table responsive hover>
          <thead>
            <tr style={{ whiteSpace: "nowrap" }}>
              <th style={{ borderBottom: "1px solid #eeeeee" }}>ລດ</th>
              <th style={{ borderBottom: "1px solid #eeeeee" }}>
                ເລກບິນແຈ້ງຖອນ
              </th>
              <th style={{ borderBottom: "1px solid #eeeeee" }}>ວັນທີແຈ້ງ</th>
              <th style={{ borderBottom: "1px solid #eeeeee" }}>ຈຳນວນເງິນ</th>
              <th style={{ borderBottom: "1px solid #eeeeee" }}>ສະຖານະ</th>
              <th style={{ borderBottom: "1px solid #eeeeee" }}>ຈັດການ</th>
            </tr>
          </thead>
          <tbody>
            {invoiceLists?.map((item, index) => (
              <tr
                key={item?.id}
                style={{ cursor: "pointer" }}
                onClick={() => setInvoiceDetail({ show: true, data: item })}>
                <td>{page * rowsPerPage + index + 1}</td>
                <td>{item?.invoiceNubmer}</td>
                <td>{moment(item?.createdAt).format("DD/MM/YYYY HH:mm")}</td>
                <td>
                  ₭ {new Intl.NumberFormat("en-US").format(item?.totalMoney)}
                </td>
                <td
                  style={{
                    color: item?.status === "REQUEST" ? "orange" : "#333",
                  }}>
                  <div>
                    {item?.status === "REQUEST"
                      ? "ລໍຖ້າຢືນຢັນ"
                      : item?.status === "REJECT"
                        ? "ຍົກເລິກແລ້ວ"
                        : "-"}
                  </div>
                </td>
                <td onClick={(e) => e.stopPropagation()}>
                  {item?.status === "REQUEST" ? (
                    <Button
                      onClick={() => handleRejectStatus(item?.id)}
                      variant="danger">
                      <FontAwesomeIcon icon={faCancel} /> &nbsp;ຍົກເລີກແຈ້ງຖອນ
                    </Button>
                  ) : (
                    ""
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <PaginationsV1
        count={invoiceListsTotal}
        rowsPerPage={rowsPerPage}
        page={page}
        pageAll={pageAll}
        onPageChange={handleChangePage}
      />
    </React.Fragment>
  );
};

const boxStyle = {
  flex: "1",
  display: "flex",
  flexDirection: "column",
  marginRight: "22px",
};
